// File for adding any widget config's types or interfaces
// As other type files have grown larger, this file is created to keep the codebase organized

import { AccountTypes, SliderInputValueType } from './ui-system-config.v2.type';
import { DatePickerTypes } from './workflow.type';

export type FormsConfigType = {
  formID: string;
  numberOfInputs: number;
  rowGap?: number | null;
  clearFormData?: boolean;
  // 'root' (default) registers formID as its own top-level form, unchanged from historic behaviour.
  // 'group' nests this widget's fields as a single named FormGroup (childKey) under parentFormID.
  // 'array' nests this widget's fields as one FormGroup entry inside a FormArray (childKey) under
  // parentFormID, at whichever index is currently pinned via WorkflowFormsService's array-edit-index state.
  formType?: 'root' | 'group' | 'array';
  parentFormID?: string; // required when formType is 'group' | 'array'
  childKey?: string; // required when formType is 'group' | 'array'
};

export type PhoneNumberConfig = {
  attachToInput?: boolean;
  showCountryFlag?: boolean;
  allowSearch?: boolean;
  showDropdownMenuCountryFlag?: boolean;
  showCountryName?: boolean;
  allowedCountryCodes?: string[];
};

export type InputWidgetConfigType = {
  name: string;

  day?: string;
  month?: string;
  year?: string;

  inputFormat: InputFormatType;
  dateFormat?: DatePickerTypes;
  label: string;
  fieldRequired: boolean;
  minLength?: number | null;
  maxLength?: number | null;
  minLengthValidationMessage?: string;
  maxLengthValidationMessage?: string;
  disableAutocomplete?: boolean;
  showEmailVerifyButton?: boolean;
  showPhoneVerifyButton?: boolean;
  phoneNumberConfig?: PhoneNumberConfig;
  inputPlaceholder?: string;
  inputHelperText?: string;
  inputLabelTooltipText?: string;
  spaceBetweenElementUnit?: string;
  spaceBetweenElementValue?: number;
  inputStyle?: string;
  currencyFormat?: string;
  accountType?: AccountTypes;
  searchEnabled?: boolean;
  textStyleClass?: string;
  defaultCurrency?: string;
  isPreselectDisabled?: boolean;
  radioCheckboxOptionsLayout?: 'horizontal' | 'vertical';
  minValue?: string;
  maxValue?: string;
  stepValue?: number;
  sliderValueType?: SliderInputValueType;
};

export enum InputFormatType {
  SHORT_TEXT_INPUT = 'short-text-input',
  DROPDOWN = 'dropdown',
  NUMBER = 'number',
  TEXT_AREA = 'text-area',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  DATE_PICKER = 'date-picker',
  EMAIL = 'email',
  PHONE_NUMBER = 'phone-number',
  CURRENCY_AMOUNT = 'currency-amount',
  SLIDER = 'slider',
  AUTOCOMPLETE = 'autocomplete',
  SWITCH = 'switch',
}
